import React from 'react'
import { graphql, HeadFC } from 'gatsby'
import CssEscape from 'css.escape'

import { Parent } from '@models/Parent'
import Layout from '@src/components/Layout'
import Seo from '@src/components/Seo'
import Link from '@atoms/Link'
import { useTranslation } from '@models/Translation'

import Gallery1 from '@src/images/projects_gallery1.webp'
import Gallery2 from '@src/images/projects_gallery2.webp'
import * as style from './style.module.sass'

type ProjectsPageProps = {
  data: {
    allParent: {
      nodes: Parent[]
    }
    allEnglishParent: {
      nodes: Parent[]
    }
  }
}

const ProjectsPage: React.FC<ProjectsPageProps> = ({ data }) => {
  const { locale, t } = useTranslation()
  const parents =
    locale === 'en' ? data.allEnglishParent.nodes : data.allParent.nodes

  return (
    <Layout design="black">
      <div>
        <header className={style.heroHeader}>
          <div className={style.headline}>
            <span className={style.subLine}>PROJECTS</span>
            <h1 className={style.title}>
              Research
              <br /> And Innovation
            </h1>
          </div>
        </header>

        <section className={style.titleWrapper}>
          <span className={style.head}>Introduction</span>
          <h2 className={style.title}>
            {t('project.title1')}
            <br />
            {t('project.title2')}
          </h2>
          <div className={style.content}>{t('project.content')}</div>
        </section>

        <section className={style.galleryWrap}>
          <ul className={style.gallery}>
            <li>
              <img src={Gallery1} alt="" />
            </li>
            <li>
              <img src={Gallery2} alt="" />
            </li>
          </ul>
        </section>

        <section className={style.listBox}>
          {locale === 'ja' && (
            <span className={style.subline}>プロジェクト一覧</span>
          )}
          <h2 className={style.headline}>All Projects</h2>
          <ul className={style.allProjects}>
            {parents.map(parent => (
              <li
                key={parent.pageId}
                className={style.item}
                style={{
                  backgroundImage: `url(${CssEscape(
                    parent.image.url,
                  )}?fm=webp&w=700&dpr=2)`,
                }}
              >
                <Link to={parent.path} className={style.link}>
                  <h3 className={style.title}>{parent.projectName}</h3>
                </Link>
              </li>
            ))}
          </ul>
        </section>
      </div>
    </Layout>
  )
}

export const Head: HeadFC = ({ location }) => (
  <Seo pathName={location.pathname} title="PROJECTS" />
)

export default ProjectsPage

export const query = graphql`
  {
    allParent(filter: { category: { eq: "projects" } }) {
      nodes {
        pageId
        path
        title
        category
        image {
          height
          url
          width
        }
        contents
        writer
        projectName
      }
    }
    allEnglishParent(filter: { category: { eq: "projects" } }) {
      nodes {
        pageId
        path
        title
        category
        image {
          height
          url
          width
        }
        contents
        writer
        projectName
      }
    }
  }
`
